import React from 'react'

export default ({ size = 36 }) => <img src='https://vo-cdn.8x8.vc/static/jaas-logo.svg' width={size} height={size} />
